import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'serviceDuration',
    standalone: false,
    pure: true
})
export class ServiceDurationPipe implements PipeTransform {
  transform(durationMinutes: number): string {
    if (!durationMinutes && durationMinutes !== 0) {return '';}
    const hours = durationMinutes / 60;
    if (hours === 1) {return '1 hr';}
    if (Number.isInteger(hours)) {return `${hours} hrs`;}
    return `${hours} hrs`;
  }
}
